/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { FormControl, MenuItem } from '@mui/material';
import { FC, useContext } from 'react';
import { DpOutlinedSelect } from '@/components/blocks/DpOutlineSelect';
import { AccountSelectSX } from '@/components/content/Account/styles/accountPersonal';

export const CatalogEntryListSort: FC = () => {
	const { sortOptions, selectedSortOption, onSortOptionChange } = useContext(
		ContentContext
	) as ReturnType<typeof useCatalogEntryList>;
	const listSettingsNLS = useLocalization('CommerceEnvironment').listSettings;
	const ProductGrid = useLocalization('ProductGrid').Labels;
	return (
		<FormControl sx={{ minWidth: '100%' }} variant="outlined">
			<DpOutlinedSelect
				data-testid="list-sort-option"
				inputProps={{ 'aria-label': ProductGrid.sortBy.t() }}
				id="productGrid_select"
				value={selectedSortOption}
				onChange={onSortOptionChange as any}
				sx={{
					...AccountSelectSX,
					'& .MuiSelect-select': {
						color: 'inherit',
					},
					borderRadius: '22px',
					width: { xs: '100%', md: '181px' },
					marginBottom: { xs: '8px', md: '0' },
					height: '44px',
					fontSize: 'var(--font-size-body)',
				}}
			>
				{sortOptions?.map((option) => (
					<MenuItem
						value={option.value}
						key={option.value}
						id={`productGrid_option_${option.value}`}
						data-testid={`productGrid_option_${option.value}`}
					>
						{listSettingsNLS[option.translationKey].t()}
					</MenuItem>
				))}
			</DpOutlinedSelect>
		</FormControl>
	);
};
